import React from 'react';
import { connect } from 'react-redux';

import { BaseLayout, LoginForm, FullPage, Container } from '@components';
import { patientActions, alertActions } from '@actions';

const Login = props => (
  <BaseLayout>
    <FullPage>
      <Container>
        <LoginForm {...props} registerLink="/register" />
      </Container>
    </FullPage>
  </BaseLayout>
);

const mapStateToProps = state => {
  const { loggingIn } = state.authentication;
  return {
    loggingIn,
  };
};

const mapDispatchToProps = dispatch => ({
  verifyUser: ({ userId, token }) =>
    dispatch(patientActions.verify({ userId, token })),
  errorAlert: err => dispatch(alertActions.error(err)),
  login: (email, password) => dispatch(patientActions.login(email, password)),
  resetPassword: email => dispatch(patientActions.resetPassword(email)),
  logInWithFacebook: token => dispatch(patientActions.loginWithFacebook(token)),
});

const connectedLoginPage = connect(mapStateToProps, mapDispatchToProps)(Login);
export default connectedLoginPage;
